export default "__VITE_ASSET__EFGV4dyc__"